import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import translationService from '../../services/translationService';
import styles from './BlogPost.module.css';

function BlogPost({ lang = 'en' }) {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const blogDoc = await getDoc(doc(db, 'blogs', id));
        if (blogDoc.exists()) {
          setBlog({
            id: blogDoc.id,
            ...blogDoc.data(),
            createdAt: blogDoc.data().createdAt?.toDate?.() || new Date(blogDoc.data().createdAt)
          });
        } else {
          setError('Blog post not found');
        }
      } catch (error) {
        console.error('Error fetching blog:', error);
        setError('Error loading blog post');
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [id]);

  // UI text translations
  const uiText = {
    en: {
      loading: 'Loading blog post...',
      error: 'Blog post not found',
      by: 'by',
      loadingError: 'Error loading blog post'
    },
    ar: {
      loading: 'جاري تحميل المقال...',
      error: 'المقال غير موجود',
      by: 'بواسطة',
      loadingError: 'حدث خطأ أثناء تحميل المقال'
    },
    tr: {
      loading: 'Blog yazısı yükleniyor...',
      error: 'Blog yazısı bulunamadı',
      by: 'tarafından',
      loadingError: 'Blog yazısı yüklenirken hata oluştu'
    }
  }[lang];

  if (loading) {
    return (
      <div className={styles.blogPost}>
        <div className={styles.loading}>{uiText.loading}</div>
      </div>
    );
  }

  if (error || !blog) {
    return (
      <div className={styles.blogPost}>
        <div className={styles.error}>{error || uiText.error}</div>
      </div>
    );
  }

  // Get translated content based on language
  const getTranslatedContent = (field) => {
    return translationService.getTranslatedContent(blog, field, lang);
  };

  return (
    <div className={styles.blogPost}>
      <div className={styles.blogHeader}>
        <h1>{getTranslatedContent('title')}</h1>
        <div className={styles.blogMeta}>
          <span>{uiText.by} {blog.author}</span>
          <span>•</span>
          <span>{blog.createdAt.toLocaleDateString(lang === 'ar' ? 'ar-EG' : lang === 'tr' ? 'tr-TR' : 'en-US')}</span>
        </div>
      </div>

      <div className={styles.blogImage}>
        <img src={blog.imageUrl} alt={getTranslatedContent('title')} />
      </div>

      <div className={styles.blogContent}>
        <div className={styles.summary}>{getTranslatedContent('summary')}</div>
        <div className={styles.content}>{getTranslatedContent('content')}</div>
      </div>
    </div>
  );
}

export default BlogPost; 